import React from "react";

const SendIcon: React.FC = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#CC4D23" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1972 20.6437C10.5203 20.0695 11.069 19.6502 11.7045 19.4861L11.8419 19.4549L31.8618 15.5231C32.8072 15.3374 33.6967 15.9373 33.8485 16.863C33.9074 17.2217 33.847 17.5929 33.678 17.9225L33.6177 18.0308L23.0758 35.4986C22.412 36.5984 20.9898 36.9936 19.8992 36.3812C19.3394 36.0668 18.9524 35.5288 18.8304 34.9033L18.8083 34.768L17.8182 27.2251L11.0688 23.7149C10.0286 23.1738 9.62031 21.9336 10.0895 20.8597L10.1412 20.7492L10.1972 20.6437ZM30.7351 18.4256L20.1157 26.8863L21.1011 34.3898L30.7351 18.4256ZM12.2084 21.6897L18.9227 25.1814L30.5048 18.0957L12.2084 21.6897Z"
        fill="white"
      />
    </svg>
  );
};

export default SendIcon;
